import Swiper from 'swiper/bundle';

// import CardsSlider from "./ZoomEffect";
export default class StoresMap{

    constructor(el){
     //   console.log(el);
        this.areas = el.querySelectorAll('.region-area');
        this.points = el.querySelectorAll('.map-point');
        this.content = el.querySelector('.stores__content');

        this.sliderElement = el.querySelector('.swiper-container');
        this.arrowPrev = el.querySelector('.slider__arrow--prev');
        this.arrowNext = el.querySelector('.slider__arrow--next');
        let pointsSorted = {};
        this.points.forEach((currentValue, index) => {
            let region = currentValue.dataset.region;
          //  console.log(region);
            if (region in pointsSorted){
                pointsSorted[region].push(currentValue);
            }else{
                pointsSorted[region] = [];
                pointsSorted[region].push(currentValue);
            }
        });
        this.pointsSorted = pointsSorted;
        //console.log(pointsSorted);
        this.init();
    }

    init(){
        const swiper = new Swiper(this.sliderElement, {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev,
            },
        });
        this.areas.forEach(area => {
            let region = area.id;
            let assignedPoints = this.pointsSorted[region];

            area.addEventListener('mouseenter', (e) => {
                this.points.forEach(point => {
                    point.classList.remove('highlight');
                });
                if (assignedPoints){
                    assignedPoints.forEach(point => {
                        point.classList.add('highlight');
                    });
                }
            });
            area.addEventListener('mouseleave', (e) => {

            });
        });

        this.points.forEach((point) => {
            let slideIndex = point.dataset.index;
            point.addEventListener('click', () =>{
                swiper.slideTo(slideIndex);
                let contentRect = this.content.getBoundingClientRect();
                window.scrollTo({
                    top: contentRect.top + window.scrollY - 80,
                    behavior: 'smooth'
                });
            })
        });

        swiper.on('slideChange', () => {
            this.points.forEach((point) => {
                if (point.dataset.index == swiper.activeIndex){
                    point.classList.add('current');
                }else{
                    point.classList.remove('current');
                }
            });
        });
    }
}